import { render, staticRenderFns } from "./SecurePaymentValid.vue?vue&type=template&id=4231edbe"
import script from "./SecurePaymentValid.vue?vue&type=script&lang=js"
export * from "./SecurePaymentValid.vue?vue&type=script&lang=js"
import style0 from "./SecurePaymentValid.vue?vue&type=style&index=0&id=4231edbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports